import React from "react";

const legendItemStyle = (bgColor) => ({
  backgroundColor: bgColor || "green",
  borderRadius: "50%",
  height: 10,
  width: 10,
  marginRight: 5,
  display: "inline-block",
});

const legendStyle = {
  boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
  font: "12px/20px 'Helvetica Neue', Arial, Helvetica, sans-serif",
  padding: "10px",
  position: "absolute",
  right: "40px",
  top: "73px",
  background: "rgba(255, 255, 255, 0.7)",
  borderRadius: "3px",
};

const DopplerLegend = (props) => (
  <div style={legendStyle}>
    <div>
      <span style={legendItemStyle("pink")}></span>
      60-100 Potential for hail
    </div>
    <div>
      <span style={legendItemStyle("red")}></span>
      50-60 Very Heavy Rain
    </div>
    <div>
      <span style={legendItemStyle("orange")}></span>
      40-50 Heavy Rain
    </div>
    <div>
      <span style={legendItemStyle("yellow")}></span>
      30-40 Moderate Rain
    </div>
    <div>
      <span style={legendItemStyle("green")}></span>
      15-30 Light Rain
    </div>
    <div>
      <span style={legendItemStyle("cyan")}></span>
      0-15 Water vapour forming
    </div>
    {props.imageTime ? (
      <div>
        Image {props.imageIndex} at {props.imageTime}
      </div>
    ) : (
      <>
        <div>Image shows maximum value </div>
        <div> per day in every location</div>
      </>
    )}
  </div>
);

export default DopplerLegend;
